import {Edit} from "./edit";
import {Save} from "./save";

wp.blocks.registerBlockType('meetravel/store-buttons', {
    title: "Bottoni Stores",
    category: 'layout',
    icon: 'heading',
    attributes: {
        justify: {
            type: 'string',
            default: 'flex-start'
        },
    },
    supports: {
        align : true
    },
    edit: Edit,
    save: Save,
})
